import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { LocaleInfoIdSchema } from '../locale/locale.types.js';
import { equipmentCategories, equipmentRoles } from './equipment.constants.js';
// ===== ID SCHEMAS =====
const EquipmentIdSchema = createIdSchema('equipment');
const EquipmentTableSelectSchema = createStrictSchema()({
    id: EquipmentIdSchema,
    canonicalName: z.string(),
    displayOrder: z.number().int().nonnegative(),
    role: z.enum(equipmentRoles),
    category: z.enum(equipmentCategories),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
const EquipmentTranslationTableSelectSchema = createStrictSchema()({
    equipmentId: EquipmentIdSchema,
    localeId: LocaleInfoIdSchema,
    nameTranslation: z.string(),
    descriptionTranslation: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== POPULATED SCHEMAS =====
// Combine data from equipmentTable and equipmentTranslationTable
const PopulatedEquipmentTableSelectSchema = EquipmentTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    name: z.string(),
    description: z.string().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by other layers) =====
const EquipmentInfoSchema = PopulatedEquipmentTableSelectSchema.extend({
    updatedAt: z.string(), // ISO date string for API
});
const EquipmentInfoIdSchema = EquipmentIdSchema;
export { EquipmentInfoIdSchema, EquipmentInfoSchema, EquipmentTableSelectSchema, EquipmentTranslationTableSelectSchema, PopulatedEquipmentTableSelectSchema, };
//# sourceMappingURL=equipment.types.js.map